import i18n from './locales/index'
import Vue from 'vue'
import appMenu from "./components/menu.vue";
import appHead from "./components/header.vue";
import appFooter from "./components/footer.vue";
import { formatDate } from './utils';
Vue.component("appMenu",appMenu)
Vue.component("appHead",appHead)
Vue.component("appFooter",appFooter)